import styled from "styled-components";

import { device } from "../../../../devices";

const DrawerAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${props => props.theme.drawer.area.background};
  padding: 2rem 1.5rem 1rem 1.5rem;
  font-family: ${props => props.theme.typography.fontFamily};
  min-height: 100%;
  @media ${device.mobileScreen} {
    padding: 0 1.5rem 0 1.5rem;
  }
`;

const DrawerAreaComponentsWrapper = styled.div`
  flex-grow: 1;
`;

export { DrawerAreaWrapper, DrawerAreaComponentsWrapper };
